export default __webpack_public_path__ + "static/media/mobile.a3e85364.jpg";